import { HTMLAttributes } from "react";

import {
  FeedbackPage,
  GameResultsConfiguration,
  GameVisuals,
  LeaderboardConfiguration,
  WelcomePage,
} from "../../gql/graphql";

import styles from "./CustomizedBackground.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export interface CustomizedBackgroundProps extends HTMLAttributes<HTMLDivElement> {
  config: FeedbackPage | GameResultsConfiguration | WelcomePage | LeaderboardConfiguration | GameVisuals | null;
}

export const CustomizedBackground = ({ config, className, children, ...rest }: CustomizedBackgroundProps) => {
  const backgroundStyles = config?.backgroundImage
    ? { backgroundImage: `url(${config.backgroundImage.url})` }
    : {
        backgroundColor: config?.backgroundColor || "#ffffff",
      };
  return (
    <div {...rest} className={cx("background", className)} style={backgroundStyles}>
      {children}
    </div>
  );
};
